import { useCallback, useEffect, useState } from 'react'
import { useGlobalContext } from '../contextoGlobal'
import { PaymentMethod } from '../types/PaymentMethod'

export type Payment = {
  pix: PaymentMethod | null
  billet: PaymentMethod | null
  creditCard: PaymentMethod | null
}

export const usePaymentMethod = () => {
  const [payment, setPayment] = useState<Payment>({
    pix: null,
    billet: null,
    creditCard: null,
  })

  const { paymentMethodStore } = useGlobalContext()

  const findPaymentMethod = useCallback(
    (slug: string): PaymentMethod | null => {
      const ACTIVE = 1
      return (
        paymentMethodStore.find(
          (payment) => payment.slug === slug && payment.status === ACTIVE
        ) ?? null
      )
    },
    [paymentMethodStore]
  )

  useEffect(() => {
    setPayment({
      pix: findPaymentMethod('pix'),
      billet: findPaymentMethod('boleto'),
      creditCard: findPaymentMethod('cartao-credito'),
    })
  }, [findPaymentMethod, paymentMethodStore])

  return {
    paymentMethodStore,
    payment,
  }
}
